import { render, staticRenderFns } from "./turntable.vue?vue&type=template&id=6d6c750e&scoped=true"
import script from "./turntable.vue?vue&type=script&lang=js"
export * from "./turntable.vue?vue&type=script&lang=js"
import style0 from "./turntable.vue?vue&type=style&index=0&id=6d6c750e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6c750e",
  null
  
)

export default component.exports